import { create } from "zustand";

interface HookProps {
  open: boolean;
  attRequestId: string;
  setAttRequestId: (id: string) => void;
  onOpenChange: (open: boolean) => void;
  otherInfo: {
    employeeName: string;
    notes: string;
  } | null;
  setOtherInfo: (
    info: {
      employeeName: string;
      notes: string;
    } | null
  ) => void;
}

export const useTakeActionModal = create<HookProps>()((set) => ({
  open: false,
  attRequestId: "",
  setAttRequestId: (id) =>
    set(() => ({
      attRequestId: id,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
  otherInfo: null,
  setOtherInfo: (info) =>
    set(() => ({
      otherInfo: info,
    })),
}));
